export default "__VITE_ASSET__BDv0VKB4__"